var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRaptorLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 222,
    viewBox: "0 0 222 222",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8205_3653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.73 0H50.28C22.5111 0 0 22.5111 0 50.28V171.31C0 199.079 22.5111 221.59 50.28 221.59H170.73C198.499 221.59 221.01 199.079 221.01 171.31V50.28C221.01 22.5111 198.499 0 170.73 0Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.21 189.02H56.21L54.03 195.02H47.62L58.5 168.31H64.91L75.79 195.02H69.34L67.21 189.02ZM65.16 183.85L61.74 176.21L58.31 183.85H65.16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.37 189.9V195.07H79.37V168.36H85.13V189.9H98.37Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.21 173.53V178.86H120.62V184.02H107.21V189.89H122.02V195.06H101.41V168.36H121.97V173.53H107.21Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.02 195.07L136.92 186.4H132.68V195.07H126.97V168.36H138.97C144.76 168.36 149.04 172.1 149.04 177.36C149.054 179.219 148.473 181.034 147.38 182.539C146.288 184.043 144.742 185.158 142.97 185.72L149.54 195.05L143.02 195.07ZM132.68 181.15H138.36C141.19 181.15 143.14 179.67 143.14 177.38C143.14 175.09 141.19 173.61 138.36 173.61H132.68V181.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.31 173.53H150.99V168.36H173.38V173.53H165.06V195.07H159.31V173.53Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.92 150.02L107.55 112.83H93.77V150.02H58.91V26.52H118.03C150.08 26.52 167.03 44.31 167.26 69.65C167.44 89.13 157.7 100.65 142.61 107.65L171.09 150.02H131.92ZM93.77 84.72H115.21C123.47 84.72 133.32 82.11 133.32 69.72C133.32 59.37 123.47 56.33 115.21 56.33H93.77V84.72Z",
    fill: "#F9A11B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8205_3653"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 221.01,
    height: 221.59,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaptorLogo);
export default __webpack_public_path__ + "static/media/raptor-logo.67dd80515ae824058b754342fcfe1d5c.svg";
export { ForwardRef as ReactComponent };